import * as React from "react";

const ChevronRightLarge: React.FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M28.9375 24L16.6233 11.6306C15.7659 10.7693 15.8684 9.34869 16.8407 8.61951L17.6097 8.04269C18.4071 7.44467 19.5231 7.52501 20.2266 8.23108L35.9375 24L20.2266 39.7689C19.5231 40.475 18.4071 40.5553 17.6097 39.9573L16.8407 39.3805C15.8684 38.6513 15.7659 37.2307 16.6233 36.3694L28.9375 24Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronRightLarge);
